module.exports = __webpack_public_path__ + "img/atg.cce32c73.svg";